const Home = () => (
  <div className="homePageWrapper">
    <div className="sideBars">
      <div className="sideBar" />
      <div className="sideBarFull" />
    </div>
    <div className="homeImg">
      <h1>
        Welcome to&nbsp;
        <span className="MathMagicianWelc">Maths Magician</span>
      </h1>
      <p className="pageIntro">
        Get ready to explore the world of mathematics. Whether you are looking
        for quick calculations or inspiring math quotes, we have got you covered.
        Lets start your mathematical journey!
      </p>
    </div>
  </div>
);

export default Home;
